import { ButtonBase, Dialog, DialogActions, Paper, styled as muiStyled } from '@mui/material'
import GreenFilledTick from 'src/assets/green_filled_tick.png'
import styled from 'styled-components'

export const UserActivityPlanBackground = styled.div`
  background: #fff;
  width: 100%;
  height: 100vh;
  font-family: Outfit;
  display: flex;
  flex-direction: column;
`

export const UserActivityPlanLayoutContainer = styled.div`
  display: flex;
  padding: 20px 0px 0px 0px;
  height: calc(100% - 64px);
  flex-direction: column;
  max-width: 1400px;
  margin: 0 auto;
  width: 100vw;
  @media (min-width: 980px) {
    max-width: ${({ onlySingleColumn }) => (onlySingleColumn ? '700px' : '1400px')};
    padding: 20px 20px 0px 20px;
    display: grid;
    justify-content: center;
    grid-template-columns: ${({ onlySingleColumn }) => (onlySingleColumn ? '1fr' : '4fr 6fr')};
  }
`

// header

export const MyPlanHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #fff;
  box-shadow: 0px 5px 25px 0px #00000040;
  height: 64px;
  padding: 0 20px;
`

export const MPPBackButtonContainer = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #fff;
  flex-shrink: 0;
  border: 1px solid #d3d8de;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  &:hover {
    background: #f2f2f2;
  }
`

export const MPHeaderTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #000000;
  @media (min-width: 980px) {
    font-size: 20px;
  }
`

// left wala section

export const MyPlanPhasesSection = styled.div`
  overflow-x: scroll;
  height: 136px;
  flex-shrink: 0;
  display: flex;
  gap: 31px;
  ${'' /* padding-left: 31px; */}
  padding-right: 31px;
  padding-top: 20px;
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  @media (min-width: 980px) {
    padding-right: 0;
    ${'' /* padding-left: 20px; */}
    padding-top: 62px;
    padding-bottom: 62px;
    flex-direction: column;
    align-items: flex-end;
    gap: 31px;
    height: calc(100% - 64px);
    overflow-x: unset;
    overflow-y: scroll;
  }
`

export const MPPhaseItemContainer = styled.div`
  width: 100%;
  padding: 32px;
  background: ${(props) => (props?.active ? '#50416c' : '#E3E3E3')};
  border-radius: 20px 0 0 20px;
  cursor: pointer;
  ${'' /* ${(props) => !props?.active && 'width: calc(100% - 44px);'}; */}
  ${'' /* ${(props) => props?.active && 'padding: 32px 76px 32px 32px;'}; */}
`

export const MPPhaseItemTitleAndProgress = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 1280px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`

export const MPPhaseItemTitle = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: ${(props) => (props?.active ? '#FFF' : '#5e5e5e')};
`

export const MPPhaseItemInfoText = styled.div`
  font-size: 14px;
  font-weight: 300;
  color: ${(props) => (props?.active ? '#ededed' : '#5e5e5e')};
`

export const MPPhaseItemCompletedText = styled.div`
  font-size: 14px;
  font-weight: 500;
  width: 130px;
  color: ${(props) => (props?.active ? '#F4CE8A' : '#BF7B00')};
  text-align: left;
  @media (min-width: 1280px) {
    margin-left: 15px;
    text-align: center;
  }
`

export const MPPhaseProgressContainer = styled.div`
  border-radius: 15px;
  background: #0000004f;
  height: 8.7px;
  width: 130px;
  flex-shrink: 0;
  overflow: hidden;
  position: relative;
  margin: 15px 0 15px 0;
  @media (min-width: 1280px) {
    margin: 0 0 5px 15px;
  }
`

export const MPPhaseProgressFilled = styled.div`
  position: absolute;
  background: #44ff33;
  top: 0;
  left: 0;
  height: 100%;
  width: ${(props) => `${props?.progress}%`};
  transition: all 0.4s ease-in-out;
`

export const MPPhaseDescription = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
  font-size: 14px;
  color: ${(props) => (props?.active ? '#DADADA' : '#7A7A7A')};
  margin-top: 20px;
`

export const MPPhaseImage = styled.img`
  border-radius: 100%;
  object-fit: contain;
  width: 50px;
  @media (min-width: 980px) {
    width: ${({ inList }) => (inList ? '40px' : '60px')};
  }
`

export const MPMobilePhaseItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  min-width: 200px;
  padding: 20px;
  flex-shrink: 0;
  background: ${(props) => (props?.active ? '#50416c' : '#E3E3E3')};
  border-radius: 20px 20px 0 0;
  cursor: pointer;
`

export const MPMobilePhaseItemTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: ${(props) => (props?.active ? '#FFF' : '#5e5e5e')};
`

export const MPMobilePhaseDescription = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
  font-size: 16px;
  color: #dadada;
  margin: 20px 0;
  width: 100%;
`

// right wala section

export const MyPlanPhaseDetailSection = styled.div`
  background: #50416c;
  perspective: 1px;
  height: 100%;
  overflow-y: scroll;
  padding: 15px;
  width: 100%;
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none;
  @media (min-width: 980px) {
    border-radius: 20px 20px 0px 0px;
    padding: 54px;
  }
  @media (min-width: 1400px) {
    border-radius: 20px 20px 0px 0px;
    padding: 54px;
  }
`

export const UserActivityPlanPhaseDayItemContainer = styled.div`
  position: relative;
  width: 100%;
  gap: 10px;
  display: flex;
  flex-direction: column;
  ${({ noBorder }) => !noBorder && 'border-top: 1px solid #ffffff4a;'}
  transition: background 150ms cubic-bezier(0.04, 0.65, 0.39, 0.98);
  ${({ showPointer }) => showPointer && 'cursor: pointer;'}
  background: ${({ active, customBackground }) => (active ? customBackground : '#50416c')};
  padding: ${({ active }) => (active ? '15px 0px' : '0px')};
  background-size: cover;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'unset')};

  @media (min-width: 980px) {
    padding: ${({ active }) => (active ? '45px 0px' : '0px')};
  }
  ${
    '' /* &:hover {
    background: #0000005e;
  } */
  }
`

export const UAPDetailedPlannedActivityDialogActions = muiStyled(DialogActions)(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-direction: column;
  @media (min-width: 576px){
    flex-direction: row;
  }
`,
)

export const ViewActivityButton = muiStyled(ButtonBase)(
  ({ theme, locked }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
 font-size: 18px;
 font-weight: 500;
 padding: 10px 20px;
 height: 52px;
  border-radius: 8px;
  position:relative;
  background: ${locked ? '#000000b8' : '#fff'};
  margin: 0 25px;
  color: ${locked ? '#fff' : '#000'};
  z-index: 1;
  @media (min-width: 980px) {
    margin: 0  35px;
  }
`,
)
export const CompletedActivityDiv = muiStyled('div')(
  ({ theme }) => `
 font-size: 18px;
 font-weight: 500;
 padding: 10px 20px;
  border-radius: 8px;
  background: #00a624;
  margin: 0 25px;
  color: #fff;
  z-index: 1;
  display:flex;
  justify-content:center;
  gap: 20px;
  @media (min-width: 980px) {
    margin: 0  35px;
  }
`,
)

export const RedoActivityButton = muiStyled(ButtonBase)(
  ({ theme }) => `
 font-size: 18px;
 font-weight: 500;
 padding: 10px 20px;
 width: 100%;
  border-radius: 8px;
  background: #41396d;
  margin: 0 25px;
  color: #fff;
  z-index: 1;
  display:flex;
  justify-content:center;
  gap: 20px;
  @media (min-width: 980px) {
    margin: 0  35px;
  }
`,
)
export const StartActvityButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  font-size: 18px;
  font-weight: 500;
  padding: 10px 20px;
  position: relative;
  width: 100%;
  border-radius: 8px;
  background: #50416c;
  color: #fff;
  transition: all 400ms ${theme.transitions.easing.quickInOut};
  gap: 8px;
  &:disabled {
    background: #c9c9c9;
    border: 1px #c9c9c9 solid;
    color: #fff;
  }
  &:hover{
    background: #6f43c1;
  }
  @media(min-width: 576px){
    min-width: 200px;
  }
`,
)
export const MarkCompletedButton = muiStyled(ButtonBase)(
  ({ theme }) => `
      font-size: 18px;
      font-weight: 500;
      width: 100%;
      position:relative;
      border-radius: 8px;
      color: #000;
      transition: all 400ms ${theme.transitions.easing.quickInOut};
      gap: 8px;
      &:disabled {
        color: #fff;
      }
      @media(min-width: 576px){
        min-width: 200px;
      }
`,
)

export const UAPDayProgressConnectorContainer = styled.div`
  ${'' /* width: 90px; */}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: normal;
`

export const UAPDayHeadingContainer = styled.div`
  flex-shrink: 0;
  display: grid;
  grid-template-columns: 3fr 1fr;
  align-items: center;
  align-items: flex-start;
  opacity: ${({ passed }) => (!passed ? '1' : '0.5')};
  ${
    '' /* padding: 0px 0px 0px 25px;
  @media (min-width: 980px) {
    padding: 0px 0px 0px 15px;
  } */
  }
`
export const UAPNextPhaseHeadingContainer = styled.div`
  flex-shrink: 0;
  display: grid;
  grid-template-columns: 3fr;
  align-items: center;
  align-items: flex-start;
  opacity: ${({ passed }) => (!passed ? '1' : '0.5')};
  padding: 0px 0px 0px 15px;
  @media (min-width: 980px) {
    padding: 0px 0px 0px 15px;
  }
`
export const UAPDetailedDayHeadingContainer = styled.div`
  flex-shrink: 0;
  display: grid;
  grid-template-columns: 3fr;
  align-items: center;
  align-items: flex-start;
`

export const UAPDayContentDividerContainer = muiStyled('div')(
  ({ theme }) => `
  align-self: normal;
  display: flex;
  flex-direction: column;
  justify-content: center;
`,
)

export const UAPDayContentDivider = muiStyled('div')(
  ({ theme, invisibleBorder }) => `
  border-right: 2px solid ${invisibleBorder ? '#ffffff00' : '#ffffff33'};
  height: 70%;
  margin: auto 0;
`,
)
export const UAPDetailedDayContentDivider = muiStyled('div')(
  ({ theme }) => `
  border-right: 2px solid #00000069;
  height: 100%;
  margin: auto 0;
`,
)

export const UAPDayHeading = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
export const UAPDetailedDayHeading = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const MPDayHeadingDateAndParticipants = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
`

export const MPDayFlagContainer = styled.div`
  background: #fff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const UAPDayThread = styled.div`
  height: 100%;
  border-right: 3px solid ${(props) => (props?.hide ? 'transparent' : '#c4c4c44f')};
`

export const UAPDayCompletionTick = styled.div`
  padding: 7px;
  flex-shrink: 0;
  border-radius: 50%;
  background: ${(props) => (props?.complete ? `url(${GreenFilledTick})` : '#e6e6e6')};
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
`

export const UAPDayItemEventsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  @media (min-width: 980px) {
    flex-direction: row;
    gap: 0px;
    align-items: center;
  }
`

export const UAPDayItemEventParent = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`

export const MPDayItemEventTimeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #5486a3;
  color: #fff;
  border-radius: 10px 10px 0 0;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  padding: 10px 10px;
  @media (min-width: 768px) {
    height: 85%;
    flex-direction: column;
    justify-content: center;
    border-radius: 10px;
    border-radius: 10px 0 0 10px;
    gap: 5px;
    margin: 0;
  }
`

export const UAPDayItemEventDetailsTitle = styled.div`
  color: #fff;
  font-weight: ${({ highlight }) => (highlight ? 300 : 400)};
  line-height: 28px;
  font-size: ${({ active, highlight }) => {
    if (active) {
      return '24px'
    }
    if (highlight) {
      return '16px'
    }
    return '14px'
  }};
  letter-spacing: ${({ highlight }) => (highlight ? '4px' : '0px')};
  @media (min-width: 980px) {
    font-size: ${({ active, highlight }) => {
      if (active) {
        return '27px'
      }
      if (highlight) {
        return '18px'
      }
      return '16px'
    }};
  }
`

export const UAPTimePlanTitlesAndCheckBoxContainer = muiStyled('div')(
  ({ theme }) => `
display: flex;
align-items: center;
gap: 10px;
padding: 0px 18px;
z-index: 1;
@media(min-width: 980px){
  padding: 0px 18px;
}
`,
)

export const UAPDayItemEventDetailsSubtitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #fff;
  font-weight: 400;
  font-size: 12px;
  gap: 5px;
  width: 100%;
  @media (min-width: 768px) {
    font-size: 14px;
  }
`
export const UAPPlannedActivityListingCategoryIcon = styled.img`
  border-radius: 10%;
  object-fit: contain;
  width: 25px;
`

export const UAPDayItemEventDetailsContainer = styled.div`
  border-radius: 10px;
  position: relative;
  padding: 10px;
  min-height: 100px;
  display: flex;
  gap: 15px;
  width: 100%;
  align-items: center;
  padding: 0px 15px;
  @media (min-width: 768px) {
    padding: 0px 20px;
  }
  ${
    '' /* &:hover {
    background: #fff;
    ${MPDayItemEventDetailsTitle} {
      color: #68a3c5;
    }
    ${MPDayItemEventDetailsSubtitle} {
      color: #68a3c5;
    }
  } */
  }
`

export const APPlannedActivityDialogPaper = muiStyled(Paper)(
  ({ theme }) => `
  max-width: 550px!important;
  width:100%;
  max-height: 550px !important;
  margin: 0 !important;
  font-family: 'Outfit';
  padding:14px;
`,
)

export const UAPActivityDetailsDialog = muiStyled(Dialog)(
  ({ theme }) => `
  .MuiDialog-container {
  align-items: flex-end;
  }
  @media (min-width: 576px){
    .MuiDialog-container {
    align-items: center;
    }
  }
`,
)

export const UAPActivityDetailsTitle = muiStyled('div')(
  ({ theme }) => `
  font-size: 26px;
  font-weight: 500;
`,
)
export const UAPActivityDetailsSubTitle = muiStyled('h6')(
  ({ theme }) => `
  font-size: 18px;
  font-weight: 500;
  margin: 0;
`,
)
export const UAPActivityDetailsTertiaryTitle = muiStyled('div')(
  ({ theme }) => `
  font-size: 14px;
  font-weight: 400;
`,
)

export const UAPDayItemEventPicture = styled.img`
  object-fit: cover;
  border-radius: 5px;
  right: 2.5px;
  width: 45px;
  height: 45px;
  @media (min-width: 980px) {
    width: 70px;
    height: 70px;
  }
`
export const UAPCategoryItemPicture = styled.img`
  object-fit: cover;
  border-radius: 5px;
  right: 2.5px;
  width: 30px;
  height: 30px;
`

export const UAPShowOtherActivitiesButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  background: transparent;
  border-radius: 50px;
  color: #fff;
  font-size: 14px;
  padding: 5px 10px;
  margin-bottom: 10px;
`,
)

export const ActivePlannedActivityBackdrop = muiStyled('div')(
  ({ theme, darker }) => `
  background: ${darker ? '#00000078' : '#0000004f'};
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
`,
)
export const LockedPlannedActivityOverlay = muiStyled('div')(
  ({ theme }) => `
  background: #000000b3;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
  pointer-events: none;
  backdrop-filter: blur(1px);
`,
)

export const LockedInfoContainer = muiStyled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  color: #fff;
  gap: 5px;
  cursor: unset;
`

export const AppExclusiveDialogPaper = muiStyled(Paper)(
  ({ theme }) => `
  max-width: unset !important;
  max-height: unset !important;
`,
)

export const PerspectiveImg = muiStyled('img')(
  ({ theme }) => `
transform: translateZ(-10px) scale(2);
height: 100%;
width: 100%;
position: absolute;
height: 100%;
width: 100%;
object-fit: cover;
z-index: -1;
`,
)

export const UAPPhaseImageStyles = muiStyled('img')(
  ({ theme }) => `
border-radius: 100%;
object-fit: cover;
width: 50px;
aspect-ratio: 1;
@media (min-width: 980px) {
  width: ${({ inList }) => (inList ? '40px' : '60px')};
}
`,
)
